<template>
  <div>
    <vx-tooltip text="Отправить оператору">
      <button
        :disabled="!currentClient.is_assigned_by_you"
        class="messenger-buttons__item"
        @click.prevent="onClick"
      >
        <feather-icon
          icon="CornerUpRightIcon"
        />
      </button>
    </vx-tooltip>
    <share-chat-popup
      v-if="showPopupShare"
      @close="showPopupShare = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ShareChatPopup from '../ShareChatPopup.vue'

export default {
  components: {
    ShareChatPopup
  },

  data () {
    return {
      showPopupShare: false
    }
  },

  computed: mapGetters(['currentClient']),

  methods: {
    onClick () {
      this.showPopupShare = true
    }
  }
}
</script>
